import React from "react";
import { observer } from "mobx-react";

import List from "../../components/List";

import AuthenticationStore from "../../stores/AuthenticationStore";
import Stores from "../../stores/Stores";
import UIStore from "../../stores/UIStore";

import Edit from "./Edit";
import SearchField from "../../components/SearchField";
import SortPanel from "../../components/SortPanel";
import SimpleSelectPanel from "../../components/SimpleSelectPanel";
import { get } from "../../utils/Client";

const store = Stores.load("customers");

class Customers extends React.Component {
  componentDidMount() {
    UIStore.init("Clientes", store);
  }

  handleDelete = () => {
    let count = store.selected.length;

    UIStore.showConfirmDialog(
      `Deseja remover ${count} clientes?`,
      "Remover Clientes"
    ).then((b) => {
      if (b) {
        store
          .delete()
          .then(() => store.query())
          .catch(() => alert("Erro!"));
      }
    });
  };

  handleFilter = () => {
    store.page = 0;
    store.searchAll = !store.searchAll;
    store.query();
  };

  onSelectReport = async (value) => {
    if(value === 0){
      const result = await get(
        `/customers/report/tsv?query=${store.queryField}` +
        `&sort=${store.sort.column}` +
        `&order=${store.sort.ascending ? "ASC" : "DESC"}`
      )
      const blob = await result.blob();
      const href = window.URL.createObjectURL(blob);
      const tempLink = document.createElement('a');
      tempLink.href = href;
      tempLink.setAttribute('download', "Relatorio_clientes.tsv");
      tempLink.click();
    }
  }


  render() {
    let toggleFilters = (
      <ul className="filters-list">
        <li>
          <div
            className={!store.searchAll ? "activated" : ""}
            onClick={this.handleFilter}
          >
            Liberados
          </div>
        </li>
        <li>
          <div
            className={store.searchAll ? "activated" : ""}
            onClick={this.handleFilter}
          >
            Todos
          </div>
        </li>
      </ul>
    );

    let canEdit;
    if (AuthenticationStore.me.role === "MANAGER") {
      canEdit = false;
    } else {
      canEdit = true;
    }

    return (
      <>
        <List
          store={store}
          data={store.list.map((i) => ({
            item: i,
            title: `${i.name} ${!!i.email ? "(" + i.email + ")" : "" }`,
            content: (
              <>
                Adicionado em:{" "}
                {i.createdDate ? i.createdDate.formatTimeStamp() : ""}
              </>
            ),
          }))}
          status={store.list.map((i) => ({
            id: i.id,
            label: i.enabled ? "Liberado" : "Desativado",
            class: i.enabled ? "finished-status" : "canceled-status",
          }))}
          rightPanel={
            <>
              <SearchField store={store} />
              <div>  
                <SimpleSelectPanel
                  label="Relatórios"
                  onSelect={this.onSelectReport}
                  options={[ { label: "Clientes", value: 0 } ]}
                  selectedLabel={""}
                />
                <SortPanel
                store={store}
                filters={{
                  name: "Nome",
                  email: "Email",
                  createdDate: "Data de Adição",
                }}
              />
              </div>
            </>
          }
          leftPanel={toggleFilters}
          onAdd={
            canEdit
              ? () =>
                  store.new({
                    name: "",
                    code: "",
                    email: "",
                    cpf: "",
                    phone: "",
                    role: "",
                  })
              : null
          }
          onEdit={canEdit ? () => store.open() : null}
          onDelete={canEdit ? () => this.handleDelete() : null}
        />

        <Edit onSave={() => AuthenticationStore.testAuthenticated()} />
      </>
    );
  }
}

export default observer(Customers);
